module.exports = __webpack_public_path__ + "img/thumb_02.99995d9d.jpg";